import { useEffect } from "react";
import { IMG_BASE_URL } from "../config/Config";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettingData } from "../redux/actions/settingAction";
// import { useTranslation } from "react-i18next";

export default function AppInitializer({ children }) {
  // const { i18n } = useTranslation();

  const dispatch = useDispatch();

  const { settingData } = useSelector(
    (state) => state?.settingdata || []
  );

  if (settingData[0]?.fav_icon) {
    const faviconUrl = `${IMG_BASE_URL}${settingData[0].fav_icon}`;
    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.id = "favicon";
      favicon.rel = "icon";
      favicon.type = "image/png";
      document.head.appendChild(favicon);
    }
    favicon.href = faviconUrl;
  }
  // useEffect(() => {
  //   const savedLang = localStorage.getItem("omens-lang") || "hi";
  //   if (savedLang) {
  //     i18n.changeLanguage(savedLang);
  //   }
  // }, [i18n]);

  useEffect(() => {
    dispatch(fetchSettingData());
  }, [dispatch]);

  return <>{children}</>;
}
